// extracted by mini-css-extract-plugin
export default {"Area":"Toggler_Area__BDYLt","Option":"Toggler_Option__kLhxJ","OptionActive":"Toggler_OptionActive__Uk7PJ"};